module.exports = __webpack_public_path__ + "static/img/5.6650775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/5.jpg
// module id = mwEt
// module chunks = 0